import React, { useState, useEffect, useRef } from 'react';
import {SENDOTP,VALIDATEOTP,AGENTOOL, GENERATETOKEN, MODULE_SKIP, GETPROFILECORP, ACTIVE_CORPORATE_FR, AMV_GENERATE_AGENT_TOKEN, AMV_GET_CRIS_PROFILE } from '../constants/constants'
import { postData } from '../constants/Utils'
import base64 from 'base-64'
import Swal from 'sweetalert2'
import logo from '../assets/logo.png'

const Authentication = ({ modulo, user, redirectTo }) => {
    
    const [token, setToken] = useState('');
    const [hideOverSession, setHideOverSession] = useState(true);
    const [hideOverlay, setHideOverlay] = useState(true);
    const [omit, setOmit] = useState(false);
    const [isCorp, setIsCorp] = useState(false);
    const [inputBlocked, setInputBlocked] = useState(false);
    const [account, setAccount] = useState("");
    const [accountCorp, setAccountCorp] = useState("");
    const [fail] = useState(undefined);
    
    const ventaFR = modulo.modulo.includes(MODULE_SKIP);
    const userData = user;
    
    // Refs para los inputs
    const memberAccountRef = useRef();
    const memberAccountCorpRef = useRef();
    const emailRef = useRef();
    const claveRef = useRef();

    useEffect(() => {
        const mod = modulo;               
        if(mod.modulo.includes(MODULE_SKIP)){
            setOmit(true);
        }
        validateToken();
        // localStorage.clear();
    }, [modulo]);

    // Preparar request para obtener tokens AMV
    const prepareAgentRequest = () => {
        const data = userData;
        
        // Construir el request usando los datos reales de userData
        const agentRequest = {
            name: data.user.name + " " + data.user.lastName,
            email: data.user.email,
            iata: data.branchOffice.printer || "N/A", // REV1-677: Usar printer en lugar de ita
            tdv: data.branchOffice.name
        };
        
        return agentRequest;
    }

    // Preparar request específico para CRIS Profile
    const prepareCrisRequest = () => {
        // Obtener activeCardNumber del estado o del input del usuario
        let activeCardNumber = account; // Se setea en callApiOTP cuando envía OTP
        
        // Si no está en el estado, intentar obtenerlo del input directamente
        if (!activeCardNumber && memberAccountRef.current) {
            activeCardNumber = memberAccountRef.current.value;
        }
        
        // Aplicar formato de 11 dígitos si es necesario
        if (activeCardNumber && activeCardNumber.length < 11) {
            activeCardNumber = modificarCuenta(activeCardNumber);
        }
        
        return {
            headerResponse: {
                idBlogLog: "",
                reservationNumber: ""
            },
            activeCardNumber: activeCardNumber || "00000000000", // Fallback por seguridad
            step: "1"
        };
    }

    // Obtener token CRIS
    const getCrisToken = async () => {
        // Paso 1: Obteniendo token CRIS...
        
        try {
            const crisRequest = prepareCrisRequest();

            
            const response = await postData(AMV_GET_CRIS_PROFILE, crisRequest);
            
            if (!response) {
                throw new Error("No se recibió respuesta del servicio CRIS");
            }
            
            if (response.wsiResult && !response.wsiResult.isSuccess) {
                throw new Error(`Error CRIS: ${response.wsiResult.message}`);
            }
            
            if (!response.crisToken) {
                throw new Error("Token CRIS no fue generado");
            }
            
            return response.crisToken;
            
        } catch (error) {
            console.error("Error obteniendo token CRIS:", error);
            showError("Error de Autenticación", error.message);
            throw error;
        }
    }

    // Obtener token AMV
    const getAmvToken = async (agentRequest) => {
        //Paso 2: Obteniendo token AMV...
        
        try {
            const response = await postData(AMV_GENERATE_AGENT_TOKEN, agentRequest);
            
            if (!response || !response.token) {
                throw new Error("Token AMV no fue generado");
            }

            return response.token;
            
        } catch (error) {
            console.error("Error obteniendo token AMV:", error);
            showError("Error del Servicio AMV", error.message);
            throw error;
        }
    }

    // Construir URL de redirección
    const buildAmvUrl = (crisToken, amvToken) => {
        console.log("Paso 3: Construyendo URL de redirección...");
        
        const mod = modulo;
        const amvUrl = `${mod.url}${crisToken}&agent=${amvToken}`;
        
        return amvUrl;
    }

    // Mostrar mensaje de error
    const showError = (title, message) => {
        setHideOverlay(true);
        Swal({
            title: title,
            text: message,
            type: 'error',
            confirmButtonText: 'Aceptar'
        });
    }

    // Mostrar mensaje de éxito y redireccionar
    const showSuccessAndRedirect = (amvUrl) => {
        // Redirección directa para AMVacations sin modal
        window.location.href = amvUrl;
    }

    // Función principal para redirigir a AM Vacations - Ticket #677
    const handleRedirectAmv = async () => {
        try {
            setHideOverlay(false);
            
            // Obtener ambos tokens
            const agentRequest = prepareAgentRequest();
            const crisToken = await getCrisToken();
            const amvToken = await getAmvToken(agentRequest);
            
            // Construir URL y redireccionar
            const amvUrl = buildAmvUrl(crisToken, amvToken);
            showSuccessAndRedirect(amvUrl);
            
        } catch (error) {
            console.error("Error en integración AM Vacations:", error);
            // Los errores específicos ya se manejan en las funciones individuales
        } finally {
            setHideOverlay(true);
        }
    }

    const validateToken = () => {
        var tokenValue = base64.decode(localStorage.getItem("franquicias"))
        if(tokenValue !== undefined && tokenValue !== null && tokenValue !== ''){
           setToken(tokenValue)
        }
    }

    const validateUrlRedirecto = (tokenValue) => {
        const data = userData;
        const mod = modulo;

        if(mod.modulo.includes(MODULE_SKIP)){
            window.location.href = mod.url + base64.encode(tokenValue);
        }else if(mod.modulo.includes('Vacations')) {
            // Integración AM Vacations - Ticket #677
            handleRedirectAmv(tokenValue);
        }
        else{
            if(memberAccountRef.current.value!==''){
                const splitLastName = data.user.lastName.split(" ");
                let requestToken = {
                    "franchiseName":    data.franchise.name,
                    "franchiseStore":   data.branchOffice.name,
                    "agentNameMember":  data.user.name,
                    "agentLastName":    splitLastName.length>1?splitLastName[0]:data.user.lastName,
                    "agentMiddleName":  splitLastName.length>1?splitLastName[1]:" ",
                    "agentEpr":         data.user.email,
                    "numberAccount":    memberAccountRef.current.value,
                    "iat":"123",
                    "exp":"123",
                    "operation": mod.operation
                }
                postData(GENERATETOKEN,requestToken).then(result =>{                    
                    if(result!==null){
                        window.location.href = mod.url + result.token;
                    }
                });
            }           
        }
    }

    const authenticateOTP = () => {
        const moduloData = modulo;
        setHideOverlay(false);
        
        var memberAccount = memberAccountRef.current.value;
        var emailValue = emailRef.current.value;
        var otp = claveRef.current.value;
        const {branchOffice,franchise,user} = userData; 
        const userVendor = `${user.lastName} ${user.name}`;
        var request = {
            "accountNumber":memberAccount.length<11?modificarCuenta(memberAccount):memberAccount,
            "email":emailValue,
            "otpCode":otp,
            "cmsEventCode":moduloData.cmsCode,
            "bussinesName":franchise.bussinesName,
            "branchOffice":branchOffice.name,
            "vendor":userVendor,
            "fail":fail
        }
        postData(VALIDATEOTP,request).then(result => {
            const {success,blocked,status} = result;
            if(success){                                   
                //VERIFICAR CLAVE OTP
                //SI ES VALIDA REDIRECCIONAR CON TOKEN 
                let tokenValue;
                let memberType = "";
                if(isCorp){
                    memberType = "CMS"
                    tokenValue = token+"&memberAccount="+accountCorp+"&MemberType="+memberType;
                }else if(!isCorp && ventaFR){
                    memberType= "PMS"
                    tokenValue = token+"&memberAccount="+account+"&MemberType="+memberType;
                }else{
                    tokenValue = token+"&memberAccount="+memberAccount;
                }
                validateUrlRedirecto(tokenValue);
                setHideOverlay(true);
            }
            if(!success){ 
                if(blocked){
                    Swal({
                        title: 'Error',
                        text: 'Debido a los intentos fallidos de autenticación, deberá esperar 6 horas para poder intentar nuevamente una reservación en la tienda Club Premier - Aeroméxico.',
                        type: 'warning',
                        cancelButtonText: 'Aceptar'
                      }).then((result) => {
                        setHideOverlay(true);
                    })
                }else{
                    Swal({
                        title: 'Error',
                        text: 'El código OTP no es válido.',
                        type: 'warning',
                        cancelButtonText: 'Aceptar'
                      }).then((result) => {
                        setHideOverlay(true);
                    })
                }
            }
            if(status!==undefined && status===502){
                Swal({
                    title: 'Error',
                    text: 'Ha ocurrido un error al validar el código OTP.',
                    type: 'warning',
                    cancelButtonText: 'Aceptar'
                  }).then((result) => {
                    setHideOverlay(true);
                })
            }
        });        
    }

    const toggleCheckboxChangeCorp = () => {
        setIsCorp(prevIsCorp => !prevIsCorp);
    };

    const modificarCuenta = (userAccount) => {
        let numeroFaltante = 11 - (userAccount.length);
        for (var i = 0; i < numeroFaltante; i++) {
            userAccount = 0 + userAccount;
        }
        return userAccount;
    }


    const validarObligatorio = (event) => {
        var userValue = event.target.value;
        let nameDivError = event.target.name
        if (userValue === "") {
            document.getElementById("ErrorCuenta"+nameDivError).innerHTML = "* Campo Requerido";
            document.getElementById("ErrorCuenta"+nameDivError).style.color = "#ab433f";
            document.getElementById("ErrorCuenta"+nameDivError).style.fontSize = ".75rem";
        } else if (validarCuenta(userValue) === false) {
            document.getElementById("ErrorCuenta"+nameDivError).innerHTML = "* Cuenta Incorrecta";
            document.getElementById("ErrorCuenta"+nameDivError).style.color = "#ab433f";
            document.getElementById("ErrorCuenta"+nameDivError).style.fontSize = ".75rem";
        } else if (validarCuenta(userValue) === true) {
            document.getElementById("ErrorCuenta"+nameDivError).innerHTML = "";
            document.getElementById("ErrorCuenta"+nameDivError).style.color = "#ab433f";
            document.getElementById("ErrorCuenta"+nameDivError).style.fontSize = ".75rem";
        }
    }

    const callApiOTP = (request) => {
        postData(SENDOTP,request).then(result => {
            if(result.success){//> Prueba Envio correcto del codigo - true
                setAccount(memberAccountRef.current.value);
                setInputBlocked(true);
                Swal({
                    title: 'Completado',
                    text: 'Se ha enviado el código correctamente.',
                    type: 'success',
                    showConfirmButton: true
                }).then((result) => {  
                    setHideOverSession(true);                  
                })
            }else{
                Swal({
                    title: 'Error',
                    text: 'Los datos ingresados no coinciden.',
                    type: 'warning',
                    cancelButtonText: 'Aceptar'
                }).then((result) => {
                    setHideOverSession(true);  
                })
            }
        }); 
    }
    const sendOTP = () => {
        const moduloData = modulo;
        setHideOverSession(false);
        
        var userValue = memberAccountRef.current.value;                            
        var emailValue = emailRef.current.value;     
        let userCorp = isCorp ? memberAccountCorpRef.current.value : null;              
        var request = {
               "accountNumber":userValue.length<11?modificarCuenta(userValue):userValue,
               "email":emailValue,
               "cmsEventCode":moduloData.cmsCode
           }
           
           if (isCorp) {
              let requestForCorp = {
                headerResponse: {
                  idBlogLog: "123",
                  reservationNumber: "123213",
              },
              activeCardNumber: userCorp,
              step: "1",
            };
            postData(
              GETPROFILECORP,
              requestForCorp
            ).then((result) =>{ 
                const {response} = result;
                const {corporate}=response.response.getCorporateProfileResult;
                const {activeStatus, adminCardNo} = corporate;
                if (activeStatus !== "ACT") {
                    throw new Error("noActiveCorp");
                }
                if(modificarCuenta(adminCardNo) !== modificarCuenta(userValue)){
                    throw new Error("noAdminCorp");
                }
                setAccountCorp(memberAccountCorpRef.current.value);
                callApiOTP(request);
            }).catch(error=>{
                let errorCorp = error.message.includes("noActiveCorp") 
                    ? "La cuenta corporativa no está activa" 
                    : error.message.includes("noAdminCorp") 
                    ? "La cuenta individual no es correcta o no es Administrativa" 
                    : "La cuenta corporativa no es correcta."            
                Swal({
                    title: 'Error',
                    text: errorCorp,
                    type: 'warning',
                    cancelButtonText: 'Aceptar'
                }).then((result) => {
                    setHideOverSession(true);  
                })
            })
          }else{
              callApiOTP(request);
          }
    }
     
    const redirectToModules = () => {
       redirectTo('Modules');
   }

   const omitAuthentication = () => {
        window.location.href = AGENTOOL + base64.encode(token);
   }

   const validarCuenta = (cuenta) => {
        if (validateAlgorithmAccount(cuenta) && (/^([0-9]{1,11})$/.test(cuenta)) ){
            return true;  
        }else{            
            return false;
        }
    }

    const validateAlgorithmAccount = (premierAccount) => {
        var luhnArr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
        var counter = 0;
        var incNum;
        var odd = false;
        var temp = String(premierAccount);
          if(+temp === 1){
            return true;
          }
        if ( temp.length === 0)
        return true
        for (var i = temp.length-1; i >= 0; --i)
        {
          incNum = parseInt(temp.charAt(i), 10);
          counter += (odd = !odd)? incNum : luhnArr[incNum];
        }
        return (counter%10 === 0);
      }

    return (
        <div className="container">
            <div className="row justify-content-center ">
                <div className=" col-11 col-md-10 col-lg-6 pt-20">
                    <div className="card signup-card">

                        <div className="card-head text-center px-15 p-md-15 bg-dark">
                            <div className="cp-logo p-15">
                                <img alt="Aeroméxico rewards" width="90%" src={logo} />
                            </div>
                        </div>
                        <div className="card-body px-15 p-md-30 ">

                            <div className="row justify-content-center">
                                <div className={`col-12 col-md-12 pt-11`}>
                                    <h4 className="card-title mb-20 ">Para poder continuar es necesario la identificación del socio.</h4>
                                    <p className=" mb-20">Ingresa los siguientes datos:</p>
                                </div>
                                <div className={`col-12 p-10`}>
                                    <input className="form-control p-10" ref={memberAccountRef} name="memberAccount" placeholder="Cuenta Aeroméxico Rewards" onChange={validarObligatorio} onBlur={validarObligatorio} disabled={inputBlocked && ventaFR}/>
                                    <div id="ErrorCuentamemberAccount" ></div>
                                </div>
                                {isCorp && ventaFR &&
                                <div className={`col-12 p-10`}>
                                    <input className="form-control p-10" required ref={memberAccountCorpRef} name="memberAccountCorp" placeholder="Cuenta Empresarial" onChange={validarObligatorio} onBlur={validarObligatorio} disabled={inputBlocked && ventaFR}/>
                                    <div id="ErrorCuentamemberAccountCorp"></div>
                                </div>}
                                <div className={`col-12 p-10`}>
                                    <input className="form-control p-10" required ref={emailRef} name="email" type="text" disabled={inputBlocked}
                                         placeholder={`Correo Electrónico asociado a la cuenta Aeroméxico Rewards`} />
                                    <div id="Erroremail"></div>
                                </div>
                                {ventaFR && ACTIVE_CORPORATE_FR === 1 &&
                                <div className={`col-12 p-10`}>
                                    <label>
                                        <input type="checkbox" name="" id="" value={isCorp} onChange={toggleCheckboxChangeCorp} disabled={inputBlocked && ventaFR}/>
                                        {" Soy una empresa"}
                                    </label>
                                </div>}
                                <div className="col-8 pt-30 ">
                                    <button className="col-12 btn btn-color-blue  p-10" onClick={sendOTP}>
                                    <span hidden={hideOverSession} className="fa fa-spinner fa-spin"></span>
                                    <span hidden={!hideOverSession}>Enviar clave de acceso</span> 
                                    
                                    </button>
                                </div>
                                <div className={`col-12 p-10 pt-30`}>
                                    <input className="form-control p-10" ref={claveRef} name="clave" type="text"
                                        required="" placeholder="Ingrese clave enviada al correo del socio." />
                                </div>
                                <div className="col-8 pt-30 ">
                                    <button className="col-12 btn btn-color-blue  p-10" onClick={authenticateOTP}>
                                        <span hidden={hideOverlay} className="fa fa-spinner fa-spin"></span>
                                        <span hidden={!hideOverlay}>Autenticar</span>                                        
                                    </button>
                                    
                                </div>

                                {
                                    omit ?
                                    <div className="col-8 pt-30 ">
                                        <button className="col-12 btn btn-color-blue  p-10" onClick={omitAuthentication}>
                                            Omitir                                        
                                        </button>
                                    </div> : 
                                    ''
                                }

                                <div className="col-8 pt-30 ">
                                    <div className="text-center pt-15">
                                        <span className="btn btn-link" onClick={redirectToModules}>
                                            Cancelar
                                        </span>
                                    </div>
                                </div>


                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
}
export default Authentication;



// WEBPACK FOOTER //
// ./src/components/Authentication.js